import { Icon } from '@pu/mpp-ui/components/icon';
import { useCSS } from '@pu/mpp-ui/hooks';
import LogoBOSvg from 'assets/Logo_BO.svg';
import msalPublicClientApplication from 'core/constants/msal.constants';
import { resetStoreAction, useAppDispatch } from 'core/store';

import './header.scss';

export interface IHeaderProps {
  userFullName: string;
  buttonClicked: boolean;
  onButtonClick: () => void;
  hideMenuButton?: boolean;
}

export const Header = ({ userFullName, buttonClicked, onButtonClick, hideMenuButton = false }: IHeaderProps) => {
  const css = useCSS('header');
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await msalPublicClientApplication.logoutPopup({
      postLogoutRedirectUri: '/login',
    });
    dispatch(resetStoreAction());
  };

  return (
    <header className={css()}>
      <div className={css('logo')}>
        {!hideMenuButton && (
          <button type="button" className={css('menu-button')} onClick={onButtonClick}>
            {buttonClicked ? <Icon name="x" weight="bold" /> : <Icon name="hamburger" weight="bold" />}
          </button>
        )}
        <img src={LogoBOSvg} alt="PU" />
      </div>
      <div className={css('user')}>
        <p className={css('user-item')}>{userFullName}</p>
        <button className={css('user-signout')} type="button" onClick={handleLogout}>
          <Icon name="sign-out" size="md" weight="bold" />
        </button>
      </div>
    </header>
  );
};
